import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { TipoRespostaService } from '../../../../../service/configuracao/tipo-resposta.service';

@Component({
  selector: 'app-consulta-tipo-resposta',
  templateUrl: './consulta-tipo-resposta.component.html',
  styleUrls: ['./consulta-tipo-resposta.component.scss']
})
export class ConsultaTipoRespostaComponent implements OnInit {
  @ViewChild('childFilter', { static: false }) child;
  @Input() itemsPerView: number = 10;

  subscription: Subscription;

  tipoRespostaSelecionada: Array<any> = [];
  loading: boolean = false;

  searchParams: any;
  requests: Array<any> = [];

  data: any = {
    primeiraPagina: true,
    ultimaPagina: false,
    paginaAtual: 1,
    totalPaginas: 1,
    totalDeItems: 0,
    itemsPorPagina: 10
  };

  tiposResposta: Array<any> = [];

  filterCurrent: any = {
    pagina: 1,
    total_pagina: 10
  };

  numeroTiposResposta: string = '10';
  visible: string = '';

  constructor(
    private router: Router,
    private tipoRespostaService: TipoRespostaService
  ) {
    this.data = [];
  }

  ngOnInit() {
    this.subscription = this.tipoRespostaService.tipoResposta$.subscribe((res: any) => {
      this.data = res;
      this.filterCurrent = this.child.searchParams;

      this.tiposResposta = res['resultado'];
      this.data['totalDeItems'] = res.totalRegistros;
      this.data['totalPaginas'] = res['totalPaginas'];
      this.data['primeiraPagina'] = res.primeiraPagina;
      this.data['ultimaPagina'] = res.ultimaPagina;

      this.loading = false;
    });

    this.getTiposResposta();
  }

  getTiposResposta() {
    this.loading = true;

    const parametros: any = {};
    parametros['pagina'] = this.data['paginaAtual'];
    parametros['total_pagina'] = this.itemsPerView;

    if (this.child && this.child.searchParams) {
      if (this.child.searchParams.descricao) {
        parametros['descricao'] = this.child.searchParams.descricao;
      } else {
        delete parametros['descricao'];
      }
      if (this.child.searchParams.hasOwnProperty('ativo')) {
        parametros['ativo'] = this.child.searchParams.ativo;
      } else {
        delete parametros['ativo'];
      }
    }

    this.tipoRespostaService.getSituacaoTipoResposta(parametros).subscribe(
      (res: any) => {
        this.loading = false;
        if (res.tamanhoPagina) {
          this.data = res;
          this.data['totalDeItems'] = res.totalRegistros;
          this.loading = false;
        }
      },
      () => {
        this.loading = false;
      }
    );
  }

  next() {
    this.data['paginaAtual']++;
    this.onPageChange(this.filterCurrent);
  }

  previous() {
    this.data['paginaAtual']--;
    this.onPageChange(this.filterCurrent);
  }

  ultimaPagina() {
    this.data['paginaAtual'] = this.data['totalPaginas'];
    this.onPageChange(this.filterCurrent);
  }

  primeiraPagina() {
    this.data['paginaAtual'] = 1;
    this.onPageChange(this.filterCurrent);
  }

  edit(codigo: number) {
    this.router.navigate([`configuracao/tipo-resposta/editar/${codigo}`]);
  }

  redirecionar() {
    this.router.navigate(['configuracao/tipo-resposta/incluir']);
  }

  ativarTiposResposta() {
    this.loading = true;
    this.visible = '';

    this.tipoRespostaSelecionada.forEach(res => {
      const value: any = {
        codigo: res.codigo,
        ativo: true,
        descricao: res.descricao
      };

      this.requests.push(this.tipoRespostaService.editaTipoResposta(value, res.codigo));
    });

    this.executarForkJoin();
  }

  inativarTiposResposta() {
    this.loading = true;
    this.visible = '';

    this.tipoRespostaSelecionada.forEach(res => {
      const value: any = {
        codigo: res.codigo,
        ativo: false,
        descricao: res.descricao
      };

      this.requests.push(this.tipoRespostaService.editaTipoResposta(value, res.codigo));
    });

    this.executarForkJoin();
  }

  executarForkJoin() {
    forkJoin(this.requests).subscribe(
      () => {
        this.tipoRespostaSelecionada = [];
        this.requests = [];
        this.loading = false;

        this.getTiposResposta();

        this.tipoRespostaService.tipoResposta$.subscribe((res: any) => {
          this.data = res;
          this.tiposResposta = res['resultado'];
          this.data['totalDeItems'] = res.totalRegistros;
          this.data['totalPaginas'] = res['totalPaginas'];
          this.loading = false;
        });
      },
      () => {
        this.tipoRespostaSelecionada = [];
        this.requests = [];
        this.loading = false;
      }
    );
  }

  toggleVisibility(item: string) {
    if (item === this.visible) {
      this.visible = '';
    } else {
      this.visible = item;
    }
  }

  onPageChange(value: any) {
    value['pagina'] = this.data['paginaAtual'];
    value['total_pagina'] = this.itemsPerView;

    this.filterCurrent = value;
    this.loading = true;

    this.tipoRespostaService.getSituacaoTipoResposta(value).subscribe(
      (res: any) => {
        this.tiposResposta = res['resultado'];
        this.loading = false;
      },
      error => {
        this.loading = false;
        console.error('Erro ao obter os tipos de resposta:', error);
      }
    );
  }

  quantidadeTiposResposta(numeroTiposResposta: string) {
    this.itemsPerView = +numeroTiposResposta;

    this.data['paginaAtual'] = 1;
    this.data['itemsPorPagina'] = this.itemsPerView;
    this.filterCurrent['total_pagina'] = this.itemsPerView;

    this.onPageChange(this.filterCurrent);

    this.data['paginaAtual'] = 1;
    this.data['itemsPorPagina'] = this.itemsPerView;

    switch (numeroTiposResposta) {
      case '10':
        this.data['itemsPorPagina'] = 10;
        break;
      case '20':
        this.data['itemsPorPagina'] = 20;
        break;
      case '50':
        this.data['itemsPorPagina'] = 50;
        break;
      case '100':
        this.data['itemsPorPagina'] = 100;
        break;
    }

    this.loading = true;
    return this.getTiposResposta();
  }

  setSelectedEntities(items: Array<any>) {
    this.tipoRespostaSelecionada = items;
  }
}
